export default __webpack_public_path__ + "static/Net_Projectile-8b37a1f05532f12bfe5cbef59b20d221.png";